import React from 'react';
export interface settingHeaderProps {
  title: string;
  desc?: string;
}

const SettingHeader = ({ title, desc }: settingHeaderProps) => {
  return (
    <header className=' pt-[28px] md:pt-0'>
      <h2 className='text-[28px] font-Poppins font-medium text-black '>{title}</h2>
      <p className='text-[#768396] font-normal text-base font-Poppins '>{desc}</p>
      <div className=' border-[#DDDDDD] hidden md:block w-[348px] border-b-[1px] my-[29px] '></div>
    </header>
  );
};

export default SettingHeader;
